import React from 'react';
import { useTranslation } from 'react-i18next';

import { AddBlock } from '@lyearn/molecules';

interface AddConditionProps {
  onClick: () => void;
  className?: string;
}

function AddCondition({ onClick, className }: AddConditionProps) {
  const { t } = useTranslation();

  return (
    <AddBlock className={className} title={t('Group:Editor.AddConditionGroup')} onClick={onClick} />
  );
}

export default AddCondition;
